import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

export interface ITabSelectItem {
  value: any;
  label: string;
  unit?: string;
  disabled?: boolean;
}

@Component({
  selector: "app-tab-select",
  templateUrl: "./tab-select.component.html",
  styleUrls: ["./tab-select.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TabSelectComponent,
      multi: true,
    },
  ],
})
export class TabSelectComponent implements OnInit, ControlValueAccessor {
  private _selected: ITabSelectItem;
  public get selected(): ITabSelectItem {
    return this._selected;
  }
  @Input() items: ITabSelectItem[] = [];
  @Input() get value(): any {
    return this._selected;
  }
  set value(value: any) {
    this._selected = value;
    this.onChangeCallback(this._selected);
    this.change.emit(this._selected);
  }
  @Input() disabled = false;
  @Output() change = new EventEmitter();
  open = false;

  constructor() {}

  ngOnInit() {
    if (!this._selected && this.items.length) {
      this._selected = this.items[0];
    }
  }

  isItemSelected(item: ITabSelectItem) {
    return item.value === this._selected.value;
  }

  selectItem(item: ITabSelectItem) {
    if (!this.disabled && !item.disabled) {
      this.value = item;
      this.open = false;
    }
  }
  toggleOpen() {
    this.open = !this.open;
  }

  writeValue(value: any): void {
    this._selected = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  private onTouchedCallback = () => {
    /* Placeholder */
  };

  private onChangeCallback = (_: any) => {
    /* Placeholder */
  };
}
